import React from 'react';
import { FormAccordion, FormAccordionItem } from 'src/UI/dynamicUI/layout/DynamicEntitySection';
import { Grid } from '@mantine/core';
import { ProductFormComponentProps } from 'src/financial/financial-data/financial-item/forms/common/FinancialFormHelpers';
import { GridPair } from 'src/financial/financial-data/financial-item/forms/common/GridPair';
import { FinancialFormField } from 'src/financial/financial-data/financial-item/forms/common/FinancialFormField';
import { GenericFinancialItemFormWrapper } from 'src/financial/financial-data/financial-item/forms/GenericFinancialItemFormWrapper';
import { OwnerSharesSection } from 'src/financial/financial-data/financial-item/forms/common/OwnerSharesSection';
import { useFlags } from 'src/feature-flags/FlagsHook';
import styles from 'src/financial/financial-data/financial-item/forms/common/FormLayout.module.css';
import { ValuationAccordionItem } from 'src/financial/financial-data/financial-item/rework/ValuationAccordionItem';
import { VALUATION_SECTION } from 'src/financial/financial-data/financial-item/rework/financialItemRework';

const SPENDING_ACCOUNT_PRODUCT = 'SpendingAccount';

export function SpendingAccount(props: ProductFormComponentProps) {
  const { flagEnabledFinancialItemOwners, flagEnabledFinancialRework } = useFlags();
  return (
    <GenericFinancialItemFormWrapper
      title={'Spending account'}
      {...props}
      product={SPENDING_ACCOUNT_PRODUCT}
      defaultJointOwner
    >
      <FormAccordion defaultValue={[VALUATION_SECTION, 'summary', 'balance', 'additional']}>
        <ValuationAccordionItem product={SPENDING_ACCOUNT_PRODUCT} />
        <FormAccordionItem value="summary" label="Summary">
          <Grid>
            <GridPair
              first={<FinancialFormField field="type" product={SPENDING_ACCOUNT_PRODUCT} />}
              second={<FinancialFormField field="description" product={SPENDING_ACCOUNT_PRODUCT} />}
            />
            <GridPair
              first={<FinancialFormField field="provider" product={SPENDING_ACCOUNT_PRODUCT} />}
            />
          </Grid>
          <Grid className={flagEnabledFinancialRework ? undefined : styles.highlightedGrid}>
            <GridPair
              first={<FinancialFormField field="account_name" product={SPENDING_ACCOUNT_PRODUCT} />}
              second={
                <FinancialFormField field="account_reference" product={SPENDING_ACCOUNT_PRODUCT} />
              }
            />

            <GridPair
              first={
                <FinancialFormField field="account_number" product={SPENDING_ACCOUNT_PRODUCT} />
              }
              second={<FinancialFormField field="sort_code" product={SPENDING_ACCOUNT_PRODUCT} />}
            />

            <GridPair
              first={
                <FinancialFormField
                  field="account_holder_name"
                  product={SPENDING_ACCOUNT_PRODUCT}
                />
              }
            />
          </Grid>
          {!flagEnabledFinancialRework && (
            <Grid>
              {flagEnabledFinancialItemOwners ? (
                <GridPair
                  fullWidth
                  first={<OwnerSharesSection product={SPENDING_ACCOUNT_PRODUCT} />}
                />
              ) : (
                <GridPair
                  first={<FinancialFormField field="is_joint" product={SPENDING_ACCOUNT_PRODUCT} />}
                />
              )}
            </Grid>
          )}
        </FormAccordionItem>
        {!flagEnabledFinancialRework && (
          <FormAccordionItem value="balance" label="Valuation">
            <Grid className={styles.highlightedGrid}>
              <GridPair
                first={
                  <FinancialFormField field="current_balance" product={SPENDING_ACCOUNT_PRODUCT} />
                }
                second={
                  <FinancialFormField field="balance_date" product={SPENDING_ACCOUNT_PRODUCT} />
                }
              />
            </Grid>
          </FormAccordionItem>
        )}
        <FormAccordionItem value="additional" label="Additional information">
          <Grid>
            <GridPair
              first={
                <FinancialFormField
                  field="withdrawal_notice_in_days"
                  product={SPENDING_ACCOUNT_PRODUCT}
                />
              }
              second={
                <FinancialFormField field="interest_rate" product={SPENDING_ACCOUNT_PRODUCT} />
              }
            />
            <GridPair
              first={
                <FinancialFormField field="overdraft_limit" product={SPENDING_ACCOUNT_PRODUCT} />
              }
              second={
                <FinancialFormField label="AER" field="aer" product={SPENDING_ACCOUNT_PRODUCT} />
              }
            />
          </Grid>
        </FormAccordionItem>
      </FormAccordion>
    </GenericFinancialItemFormWrapper>
  );
}
